/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowShapeTriangleARightIcon16Solid = forwardRef('ArrowShapeTriangleARightIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M5 11.348V4.651a.9.9 0 0 1 1.388-.756l5.19 3.349a.9.9 0 0 1 0 1.512l-5.19 3.348A.9.9 0 0 1 5 11.348Z" })));
});
